import { useCallback } from 'react';

import { ANALYTICS_EVENTS } from '@/constants/analytics';
import type { ProductSupportEligibilityResult } from '@/services/getProductSupportEligibilityV2';
import { segmentClient } from '@/util/analytics';

type EligibilityRequestStatus = 'not_requested' | 'stale' | 'succeeded' | 'failed';

type TrackProductSupportEvaluatedParams = {
  source: string;
  inquiryId?: number;
  requestStatus: EligibilityRequestStatus;
  eligibility: ProductSupportEligibilityResult | null;
  cancerFocusId: string;
  messageLength: number;
};

export function useProductSupportPostSubmitAnalytics() {
  const trackProductSupportEvaluated = useCallback(
    ({
      source,
      inquiryId,
      requestStatus,
      eligibility,
      cancerFocusId,
      messageLength,
    }: TrackProductSupportEvaluatedParams) => {
      Promise.resolve(
        segmentClient.track(ANALYTICS_EVENTS.MOD_PRODUCT_SUPPORT_EVALUATED, {
          source,
          inquiryId: inquiryId ?? null,
          requestStatus,
          isEligible: eligibility?.isEligible === true,
          detectedProductId: eligibility?.productId ?? undefined,
          cancerFocusId,
          messageLength,
          ruleSetId: eligibility?.ruleSetId,
          matchedTermsCount: eligibility?.matchedTerms.length ?? 0,
        })
      ).catch(() => undefined);
    },
    []
  );

  return {
    trackProductSupportEvaluated,
  };
}
